import React, { Component } from "react";
import {
    Checkbox
} from "antd";
import PropTypes from "prop-types";

const btnStyle = {
    fontWeight: "500",
    fontSize: "18px",
    lineHeight: "21px",
    height: "22px",
    textAlign: "center",
    cursor: "pointer",
    padding: "0px 5px",
    border: "1px solid rgba(0, 0, 0, 0.12)"
};

export default class DaysCalculator extends Component {
    state = {
        days: this.props.days,
        checked: this.props.checked
    }

    changeDays = (action) => {
        if(this.state.checked && !this.state.days || (this.state.days >= 0 && this.state.days <= 20)) {
            switch(action) {
            case "plus":
                this.setState({
                    days: !this.state.days ? 1 : (this.state.days < 20 ? this.state.days + 1 : 20)
                }, () => {
                    this.props.updateDays(this.state.days);
                });
                break;
            case "minus":
                this.setState({
                    days: this.state.days > 0 ? this.state.days - 1 : 0
                }, () => {
                    this.props.updateDays(this.state.days);
                });
                break;
            }
        }
    }

    onChangeCheckbox = e => {
        this.setState({
            checked: e.target.checked,
            days: !e.target.checked ? null : this.state.days
        }, () => {
            if(!this.state.checked) {
                this.props.updateDays(null);
            }
        });
    };

    render() {
        return (
            <div className={"d-flex flex-row justify-content-space-between"}>
                <Checkbox className={"fb-40"} checked={this.state.checked} onChange={this.onChangeCheckbox}>Fixed</Checkbox>
                <div style={{
                    paddingLeft: "30px",
                    width: "140px",
                    alignItems: "center",
                    lineHeight: "20px"
                }} className={"d-flex flex-row justify-content-space-between"}>
                    <span style={btnStyle} onClick={this.changeDays.bind(null, "minus")}>-</span>
                    <span style={{
                        padding: "0 5px",
                        border: "1px solid rgba(0, 0, 0, 0.12)",
                        height: "20px",
                        fontSize: "12px"
                    }}> {this.state.days} Days </span>
                    <span style={btnStyle} onClick={this.changeDays.bind(null, "plus")}>+</span>
                </div>
            </div>
        );
    }
}

DaysCalculator.propTypes = {
    days: PropTypes.number,
    isFieldChecked: PropTypes.bool,
    updateDays: PropTypes.func,
    checked: PropTypes.bool
};